const recipient = 'lesia_khvorostina@yahoo.com';

export const handleSendEmail = ({subject, body}: { subject?: string, body?: string }) => {
    const defaultSubject = 'Art development contact';
    const defaultBody = ''; // Optional: Email body

    let mailtoLink = 'mailto:' + encodeURIComponent(recipient);

    mailtoLink += '?subject=' + encodeURIComponent(subject || defaultSubject);

    if (subject) {
        mailtoLink += '&body=' + encodeURIComponent(body || defaultBody);
    } else {
        mailtoLink += '?body=' + encodeURIComponent(body || defaultBody);
    }

    window.location.href = mailtoLink;
}
